export const ANSOKAN_ROUTING_NAMES = {
    ATTACHMENT: 'attachment',
    CONFIRMATION: 'confirmation',
    CONTACT_INFO: 'contact-info',
    DEGREE: 'degree',
    OTHER_QUALIFICATION: 'other-qualification',
    REVIEW: 'review',
    SPECIAL_EDUCATION_TEACHER: 'special-education',
    START: 'start',
    VOCATIONAL_QUALIFICATION: 'vocational-qualification',
};
